import { jsx as t, jsxs as i } from "react/jsx-runtime";
import "react";
var h = (l) => /* @__PURE__ */ i("svg", {
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...l,
  children: [
    /* @__PURE__ */ t("rect", {
      width: 20,
      height: 20,
      fill: "#F5F5F5"
    }),
    /* @__PURE__ */ t("rect", {
      width: 1876,
      height: 988,
      transform: "translate(-1660 -432)",
      fill: "white"
    }),
    /* @__PURE__ */ t("path", {
      d: "M20 0H0V20H20V0Z",
      fill: "#D80027"
    }),
    /* @__PURE__ */ t("path", {
      d: "M14.5709 10L12.7033 10.8785L13.6978 12.6873L11.6697 12.2993L11.4128 14.3478L10.0002 12.8412L8.58766 14.3478L8.33066 12.2993L6.30281 12.6872L7.29723 10.8784L5.42969 10L7.29727 9.12164L6.30281 7.31281L8.33062 7.70085L8.58777 5.65222L10.0002 7.15886L11.4129 5.65222L11.6697 7.70085L13.6979 7.31281L12.7033 9.12171L14.5709 10Z",
      fill: "#FFDA44"
    }),
    /* @__PURE__ */ t("path", {
      d: "M10.0006 12.8443C11.5715 12.8443 12.8449 11.5709 12.8449 9.99998C12.8449 8.42909 11.5715 7.15564 10.0006 7.15564C8.4297 7.15564 7.15625 8.42909 7.15625 9.99998C7.15625 11.5709 8.4297 12.8443 10.0006 12.8443Z",
      fill: "#D80027"
    }),
    /* @__PURE__ */ t("path", {
      d: "M8.57793 10C8.50945 10 8.4418 10.0035 8.375 10.0102C8.37742 10.4041 8.52 10.7647 8.75535 11.0448C8.88098 10.7068 9.06844 10.3987 9.30488 10.135C9.07902 10.0481 8.83402 10 8.57793 10Z",
      fill: "#FFDA44"
    }),
    /* @__PURE__ */ t("path", {
      d: "M9.45312 11.5308C9.62398 11.5919 9.80797 11.6254 9.9998 11.6254C10.1917 11.6254 10.3756 11.5919 10.5465 11.5308C10.4534 11.1653 10.2611 10.839 9.9998 10.5826C9.73855 10.839 9.54625 11.1654 9.45312 11.5308Z",
      fill: "#FFDA44"
    }),
    /* @__PURE__ */ t("path", {
      d: "M11.4069 9.18756C11.1258 8.70178 10.601 8.37463 9.99934 8.37463C9.39773 8.37463 8.87285 8.70178 8.5918 9.18756C9.10418 9.19018 9.58457 9.32948 9.99934 9.56999C10.4141 9.32948 10.8945 9.19014 11.4069 9.18756Z",
      fill: "#FFDA44"
    }),
    /* @__PURE__ */ t("path", {
      d: "M10.6953 10.135C10.9318 10.3987 11.1193 10.7068 11.2449 11.0448C11.4803 10.7647 11.6228 10.4041 11.6253 10.0102C11.5585 10.0035 11.4908 10 11.4223 10C11.1662 9.99996 10.9213 10.048 10.6953 10.135Z",
      fill: "#FFDA44"
    })
  ]
});
export {
  h as default
};
